// Hard-centre badge images on mobile, but ONLY on product pages
document.addEventListener('DOMContentLoaded', function () {
  // Only run on small/mobile screens
  if (window.innerWidth > 749) return;

  // Only run on product pages (URLs like /products/...)
  if (!window.location.pathname.includes('/products/')) return;

  // Select all badge images by alt text ending in "Badge"
  var badgeImages = document.querySelectorAll('main img[alt$="Badge"]');

  badgeImages.forEach(function (img) {
    // Reset any previous manual offsets
    img.style.position = 'relative';
    img.style.left = '0px';
    img.style.marginLeft = 'auto';
    img.style.marginRight = 'auto';
    img.style.display = 'block';

    // Measure its current position
    var rect = img.getBoundingClientRect();
    var viewportWidth = window.innerWidth;

    // Calculate how far we need to move it horizontally to centre it
    var offset = (viewportWidth - rect.width) / 2 - rect.left;

    // Apply the shift
    img.style.left = offset + 'px';
  });
});

// WX-DEP-093 // One zoom only on product images.
// The theme lightbox opened full-screen, then a second click zoomed to full pixel size.
// Lock every zoom level to fit-to-screen; a click inside the lightbox now closes it.
(function () {
  if (!window.customElements) return;
  var fit = function (z) { return z.fit; };
  var lock = function () {
    document.querySelectorAll('product-gallery').forEach(function (pg) {
      try {
        var lb = pg.lightBox;
        if (!lb || !lb.options) return;
        Object.assign(lb.options, { initialZoomLevel: fit, secondaryZoomLevel: fit, maxZoomLevel: fit, imageClickAction: 'close', tapAction: 'close', doubleTapAction: false, wheelToZoom: false });
      } catch (e) {}
    });
  };
  customElements.whenDefined('product-gallery').then(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lock); else lock();
  });
})();